import { motion } from "framer-motion";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const TOWNS = ["Flint", "Grand Blanc", "Fenton", "Davison", "Burton", "Flushing", "Swartz Creek", "Clio", "Mt. Morris", "Linden", "Goodrich", "Otisville", "Gaines", "Atlas"];

export const ServiceArea = () => (
    <section id="turf" data-testid="service-area-section" className="bg-monster-cream py-24 sm:py-32">
        <div className="mx-auto grid max-w-6xl items-start gap-14 px-5 lg:grid-cols-2">
            <div>
                <SectionHeading
                    number="03"
                    title="Our"
                    highlight="turf."
                    sub="We deliver monsters all across Genesee County and the surrounding areas. Outside the zone? Call us — we roam farther for bigger parties."
                />
                <div className="flex flex-wrap gap-3">
                    {TOWNS.map((town, i) => (
                        <motion.span
                            key={town}
                            initial={{ opacity: 0, scale: 0.7 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ type: "spring", stiffness: 200, damping: 14, delay: i * 0.04 }}
                            className="rounded-full border-2 border-monster-navy bg-white px-4 py-2 font-display text-sm font-semibold text-monster-navy shadow-sticker-sm"
                        >
                            {town}
                        </motion.span>
                    ))}
                </div>
            </div>
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ type: "spring", stiffness: 80, damping: 15 }}
                className="rounded-[32px] border-2 border-monster-navy bg-monster-blue p-8 shadow-sticker-lg sm:p-10"
            >
                <h3 className="font-display text-3xl font-semibold text-white">Talk to a human</h3>
                <p className="mt-2 text-sm font-semibold text-white/70">Real people. Real fast answers. Usually within the hour.</p>
                <div className="mt-8 space-y-5">
                    <a data-testid="contact-phone-link" href="tel:+18104441076" className="flex items-center gap-4 rounded-2xl border-2 border-monster-navy bg-white p-4 shadow-sticker-sm transition-transform hover:-translate-y-1">
                        <span className="flex h-11 w-11 items-center justify-center rounded-full border-2 border-monster-navy bg-monster-green">
                            <Phone className="h-5 w-5 text-monster-navy" />
                        </span>
                        <span>
                            <span className="block text-xs font-bold uppercase tracking-wider text-monster-navy/50">Call or text</span>
                            <span className="font-display text-lg font-semibold text-monster-navy">(810) 444-1076</span>
                        </span>
                    </a>
                    <a data-testid="contact-email-link" href="mailto:MonstersInflatables@gmail.com" className="flex items-center gap-4 rounded-2xl border-2 border-monster-navy bg-white p-4 shadow-sticker-sm transition-transform hover:-translate-y-1">
                        <span className="flex h-11 w-11 items-center justify-center rounded-full border-2 border-monster-navy bg-monster-yellow">
                            <Mail className="h-5 w-5 text-monster-navy" />
                        </span>
                        <span className="min-w-0">
                            <span className="block text-xs font-bold uppercase tracking-wider text-monster-navy/50">Email us</span>
                            <span className="block truncate font-display text-base font-semibold text-monster-navy">MonstersInflatables@gmail.com</span>
                        </span>
                    </a>
                    <div className="flex items-center gap-4 rounded-2xl border-2 border-monster-navy bg-white p-4 shadow-sticker-sm">
                        <span className="flex h-11 w-11 items-center justify-center rounded-full border-2 border-monster-navy bg-monster-red">
                            <Clock className="h-5 w-5 text-white" />
                        </span>
                        <span>
                            <span className="block text-xs font-bold uppercase tracking-wider text-monster-navy/50">Party hours</span>
                            <span className="font-display text-lg font-semibold text-monster-navy">7 days a week, 8am – 8pm</span>
                        </span>
                    </div>
                    <div className="flex items-center gap-3 rounded-2xl border-2 border-dashed border-white/40 p-4 text-sm font-semibold text-white/85">
                        <MapPin className="h-5 w-5 shrink-0 text-monster-yellow" />
                        Based in Genesee County, Michigan — we come to you.
                    </div>
                </div>
            </motion.div>
        </div>
    </section>
);
